import React          from 'react';
import numeral        from 'numeral';
import RadioComponent from './RadioComponent';
import Label          from './Label';
import Tooltip        from './Tooltip';

const StencilLengthText = (props) => {
  const name = 'stencils_border';
  const onChange = e => props.onChangeParameter(name, e.target.value);
  let value = props.parameters.get(name);
  if (typeof value === 'number') {
    if (value === 1) {
      value = numeral(value).format('0.0');
    } else {
      value = value.toString();
    }
  }
  return (
    <div className="form-group">
      <Label label={props.label} required={props.required} /> {' '}
      <Tooltip id={`tooltip-${name}`} title={props.tooltip} />
      <div>
        <RadioComponent
          checked={value === '1.0'}
          inline
          inputClassName={props.inputClassName}
          inputId="stencil-border-1"
          label="1.0 inch"
          name={name}
          onChange={onChange}
          value="1.0" />
        <RadioComponent
          checked={value === '0.5'}
          inline
          inputClassName={props.inputClassName}
          inputId="stencil-border-0-5"
          label="0.5 inch"
          name={name}
          onChange={onChange}
          value="0.5" />
        <RadioComponent
          checked={value === '0'}
          inline
          inputClassName={props.inputClassName}
          inputId="stencil-border-0"
          label="No Margin"
          name={name}
          onChange={onChange}
          value="0" />
      </div>
    </div>
  );
};

StencilLengthText.defaultProps = {
  required: true,
  label   : 'Stencil Margin(for each side)',
};

export default StencilLengthText;
